const ufeApi = require('services/api/ufeApi');

function gamificationUniversal(token, body) {
    const sdnDomain = Sephora.configurationSettings.sdnDomainBaseUrl;
    const url = `${sdnDomain}/v1/topics/Sephora.Loyalty.Gamification.Universal`;

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/vnd.kafka.json.v2+json',
                Accept: 'application/vnd.kafka.v2+json',
                authorization: `Bearer ${token}`
            },
            body: JSON.stringify(body)
        })
        .then(data => data);
}

module.exports = { gamificationUniversal };
